import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { Institution } from '../../profile/pages/institution-page/interface/institution.interface';

@Injectable({
  providedIn: 'root',
})
export class InstitutionsService {
  private baseUrl: string = env.apiUrl;

  constructor(private http: HttpClient) {}

  getInstitutions(): Observable<Institution> {
    return this.http.get<Institution>(
      `${this.baseUrl}/institution/instDropDown`
    );
  }
}
